var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#A50D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6401 13.475L21.0276 8.8625C20.993 8.8272 20.9518 8.79909 20.9063 8.77978C20.8608 8.76048 20.8119 8.75035 20.7625 8.75H14.2375C14.1381 8.75002 14.0427 8.78954 13.9724 8.85987L9.35987 13.475C9.29018 13.5447 9.25071 13.639 9.25 13.7375V20.2625C9.25002 20.3619 9.28954 20.4573 9.35987 20.5276L13.9724 25.1401C14.0427 25.2105 14.1381 25.25 14.2375 25.25H20.7625C20.8619 25.25 20.9573 25.2105 21.0276 25.1401L25.6401 20.5276C25.7105 20.4573 25.75 20.3619 25.75 20.2625V13.7375C25.7493 13.639 25.7098 13.5447 25.6401 13.475ZM17.5 22.25C17.3517 22.25 17.2067 22.206 17.0833 22.1236C16.96 22.0412 16.8639 21.9241 16.8071 21.787C16.7503 21.65 16.7355 21.4992 16.7644 21.3537C16.7933 21.2082 16.8648 21.0746 16.9697 20.9697C17.0746 20.8648 17.2082 20.7934 17.3537 20.7644C17.4992 20.7355 17.65 20.7503 17.787 20.8071C17.9241 20.8639 18.0412 20.96 18.1236 21.0833C18.206 21.2067 18.25 21.3517 18.25 21.5C18.25 21.6989 18.171 21.8897 18.0303 22.0303C17.8897 22.171 17.6989 22.25 17.5 22.25ZM17.8919 19.3141H17.1227L16.75 11.5576H18.2661L17.8919 19.3141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastIcon);
export default __webpack_public_path__ + "static/media/error-toast-icon.462d68b0d0fdc584344968c3b0373f6e.svg";
export { ForwardRef as ReactComponent };